import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICoreService } from "../CoreServicesModel";

export const getAllCoreServices = createAsyncThunk(
  "CoreServices/FindAllCoreService",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/FindAllCoreService`,
        {
          ServiceName: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Core Services:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createCoreService = createAsyncThunk(
  "CoreServices/InsertCoreServices",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/InsertCoreServices`,
        formdata,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Core Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateCoreService = createAsyncThunk(
  "CoreServices/UpdateCoreServices",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/UpdateCoreServices`,
        formdata,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Core Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteCoreService = createAsyncThunk(
  "CoreServices/DeleteCoreServices",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/DeleteCoreServices`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Core Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getCoreServiceByID = createAsyncThunk(
  "CoreServices/FindByIDCoreServices",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/FindByIDCoreServices`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ServicesID: result.ServicesID,
        ServiceName: result.ServiceName,
        CoreService: result.CoreService,
        URL: result.URL,
        LongDescription: result.LongDescription,
        SortDescription: result.SortDescription,
        MainImage: result.MainImage,
        IconImage: result.IconImage,
        IsActive: result.IsActive ? 1 : 2,
      } as ICoreService;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Blog :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveCoreService = createAsyncThunk(
  "CoreServices/FindAllActiveCoreService",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/CoreServices/FindAllActiveCoreService`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Core Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveCoreService = createAsyncThunk(
  "CoreServices/ActiveInActiveCoreServices",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/ActiveInActiveCoreServices`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Core Service :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

export const CoreServiceImageUpload = createAsyncThunk(
  "CoreServices/CoreServiceImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CoreServices/CoreServiceImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Core Service Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
